module.exports = __webpack_public_path__ + "img/legacy_5.e1070f0d.jpg";